import { useCallback } from 'react';

export const formatTelefono = (value: string): string => {
    // Eliminar todo excepto números
    const digits = value.replace(/\D/g, '');
    
    // Limitar a 10 dígitos máximo
    const limitedDigits = digits.slice(0, 10);
    
    const codigoArea = limitedDigits.slice(0, 3);    // Primeros 3 dígitos (809, 829, 849)
    const parte1 = limitedDigits.slice(3, 6);        // Siguientes 3 dígitos
    const parte2 = limitedDigits.slice(6, 10);       // Últimos 4 dígitos

    // Construir el formato (809) 000-0000
    if (!codigoArea) return '';
    
    let formatted = `(${codigoArea}`;
    if (codigoArea.length === 3) {
        formatted += ')';
        if (parte1) {
            formatted += ` ${parte1}`;
            if (parte2) {
                formatted += `-${parte2}`;
            }
        }
    }

    return formatted;
}

export const useFormatTelefono = () => {
    const onChangeHandler = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>, onChange?: (value: string) => void) => {
            const formatted = formatTelefono(e.target.value);
            e.target.value = formatted;
            if (onChange) onChange(formatted);
        },
        []
    );

    return {
        formatTelefono,
        onChangeHandler
    };
}